import { Route } from 'react-router-dom'

// routes
import { PUBLIC_ROUTES, ROOT_ROUTE } from '../../routes'

// pages
import LoginForm from '../login/LoginForm'
import SetPassword from '../login/setPassword'
import LinkExpired from '../login/linkExpired'
import UpdatePassword from '../login/updatePassword'
import ForgotPassword from '../login/forgotPassword'
import LoginLayout from '../../layouts/LoginLayout/LoginLayout'
import SuccessfullyResetPassword from '../login/successfullyResetPassword'

const PublicRoutesList = () => {
    return (
        <>
            <Route element={<LoginLayout />}>
                <Route path={ROOT_ROUTE} element={<></>} />
                <Route path={PUBLIC_ROUTES.login} element={<LoginForm />} />
                <Route
                    path={PUBLIC_ROUTES.forgotPassword}
                    element={<ForgotPassword />}
                />
                <Route
                    path={PUBLIC_ROUTES.setPassword}
                    element={<SetPassword />}
                />

                <Route
                    path={PUBLIC_ROUTES.updatePassword}
                    element={<UpdatePassword />}
                />
                <Route
                    path={PUBLIC_ROUTES.successfullyResetPassword}
                    element={<SuccessfullyResetPassword />}
                />
                <Route
                    path={PUBLIC_ROUTES.linkExpired}
                    element={<LinkExpired />}
                />
            </Route>
        </>
    )
}

export default PublicRoutesList
